import { Text } from 'react-native';
import styled from 'styled-components/native';

export const Suffix = styled(Text)`
    color: ${({ theme }) => theme.text.tertiary};
`;
